// import { get, set } from 'svelte/store';
import {

  writableArray
} from '../stores.js';

export function asnavigate(navigate, page) {
  // saveSessionTrappe(`asnavigate ${page}`);
  // import { savetosession, saveCommande } from '../Utils/savetosession';


  // const navigate = useNavigate();
  // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
  // console.log(nomTrappe.get());
  // console.log(get(trappes));

  // let trappesStore = get(trappes);
  // console.log(trappesStore['nomTrappe']);
  // console.log(get(trappesStore['nomTrappe']));
  // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
  // writableArray = [...writableArray, {
  //   name: Math.random()
  // }];
  // console.log(get(writableArray));
  // document.body.scrollTop = 0; // For Safari
  // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  navigate(page);
  // callBack(id);
  // alert('asnavigate');
}
// });
// onMount(asnavigate)
